<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('profileparameter_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-profileparameter-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.profileparameter.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.profileparameter.bracket') }}</strong></td>
              <td>
                                    {{ item['bracket'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.profileparameter.unit') }}</strong></td>
              <td>
                                    {{ item['Unit'] }}
              </td>

              <td><strong>{{ $t('profile.profileparameter.tab') }}</strong></td>
              <td>
                                    {{ item['tab'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.profileparameter.section0') }}</strong></td>
              <td>
                                    {{ item['section0'] }}
              </td>

              <td><strong>{{ $t('profile.profileparameter.section1') }}</strong></td>
              <td>
                                    {{ item['section1'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.profileparameter.softwareversion') }}</strong></td>
              <td>
                                    {{ item['softwareVersion'].name }}
              </td>

              <td></td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ProfileParameter';

export default {
  name: 'ProfileParameterShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('profileparameter', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profileparameter', ['find'])
  },
  methods: {
    ...mapActions('profileparameter', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
